import {
    BANK_CASH_ITEM_TYPE_LABELS,
    BankCashItemType,
} from "@common/types/bankCashItem";

export function cashItemTypeOf(amount: number | null): BankCashItemType | null {
    if (amount === null || amount === 0) {
        return null;
    }
    return amount < 0 ? BankCashItemType.CHECK : BankCashItemType.DEPOSIT;
}

export function cashItemTypeLabel(amount: number | null): string {
    const type = cashItemTypeOf(amount);
    return type ? BANK_CASH_ITEM_TYPE_LABELS[type] : "";
}
